import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-02d7d8f2")

_pushScopeId("data-v-02d7d8f2")
const _hoisted_1 = /*#__PURE__*/_createVNode("svg", {
  class: "icon",
  "aria-hidden": "true",
  "font-size": "20px"
}, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "#iconhamburger" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: [{'is-active': _ctx.isActive}],
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleClick && _ctx.toggleClick(...args)))
  }, [
    _hoisted_1
  ], 2))
})